export const CohortPageRoutes = {
  HOME_OWNERS: {
    REFINANCING: '/home-owners/refinancing',
    BUYING: '/home-owners/buying',
    TAILORED: '/tailored',
  },
  INVESTORS: {
    REFINANCING: '/investors/refinancing',
    BUYING: '/investors/buying',
    TAILORED: '/tailored',
  },
  TAILORED: {
    SELF_EMPLOYED: '/tailored#self-employed',
    COMPANIES_AND_TRUSTS: '/tailored#companies-and-trusts',
    LOWER_DEPOSIT: '/tailored#lower-deposit',
    OTHER_SPECIALISED: '/tailored#other-specialised',
  },
} as const;
